<template>
  <v-container
    id="create-account"
    class="fill-height justify-center align-start">
    <img
      class="_bench-banner _ps-fixed"
      src="/img/account/bench-banner.jpg"
      loading="lazy"
      alt="Bench Banner Image"
    />
    <v-row
      align-content="center"
      justify="center">
      <v-col lg="8">
        <v-tabs v-model="selectedTab">
          <v-tab :href="`#choose`">
            ทำรายการสั่งซื้อ
          </v-tab>
          <v-tab :href="`#hide`">
            ซ่อนบัญชี
          </v-tab>
        </v-tabs>
        <v-card class="d-flex flex-column justify-center pa-10">
          <v-tabs-items v-model="selectedTab">
            <v-tab-item value="choose">
              <line-official-account-choose />
            </v-tab-item>
            <v-tab-item value="hide">
              <line-official-account-hide />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LineOfficialAccountIndexPage',
  components: {
    LineOfficialAccountChoose: () => import('@/components/LineOfficialAccount/Choose'),
    LineOfficialAccountHide: () => import('@/components/LineOfficialAccount/Hide')
  },
  data() {
    return {
      selectedTab: ''
    }
  }
}
</script>

<style lang="scss" scoped>
._bench-banner {
  width: 100%;
  bottom: 0;

  @media only screen and (min-width: 1264px) {
    width: calc(100% - 220px);
    left: 220px;
    bottom: 10%;
  }
}
</style>
